import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
import vailcode from "@utils/errcode";
import formatter from "@utils/formatter";
export default {
  name: "reward",
  props: {
    data: null
  },
  computed: {
    ...taskVuex.mapState(["timerObjs"]),
    fmt_pre() {
      return formatter.fmt_pre;
    }
  },
  data() {
    return {
      isBalanceChange: false
    };
  },
  watch: {
    data: {
      handler(val) {
        if (val) {
          this.isBalanceChange = false;
          setTimeout(() => {
            this.isBalanceChange = true;
          }, 2000);
        }
      },
      deep: true
    },
    "$parent.popRewardShow": {
      handler(bool) {
        if (!bool) {
          this.isBalanceChange = false;
          console.log("this.$parent.rewardData", this.$parent.rewardData);
          if (this.$parent.rewardData) {
            this.$emit("finish", this.data);
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    confirmFn() {
      this.$parent.popRewardShow = false;
    }
  }
};